<div class="aic-one-console aic-mobile-page aic-dashboard-page">
    <!-- Top Navbar -->
    <Navbar />

    <div class="page-wrapper aic-mobile-content">
      <!-- Left Sidebar -->
      <Sidebar />

      <!-- Main surface -->
      <div class="hero-section w-100 soft-card aic-safe-bottom">
        <!-- Welcome / Summary -->
        <div class="card border border-0 border-dark border-opacity-75 rounded-4 shadow-lg mb-4">
          <div class="card-body p-3 p-md-4">
            <div class="d-flex flex-column flex-xxl-row align-items-start align-items-xxl-center justify-content-xxl-between gap-3">
              <div v-if="active_dashboard_mode === 'my'">
                <h4 class="dashboard-greeting-title mb-0 text-start">
                  <span class="dashboard-greeting-lead">{{ dashboard_greeting }}, {{ user_first_name }}</span>
                  <span class="dashboard-greeting-separator" aria-hidden="true">&mdash;</span>
                  <span class="dashboard-greeting-summary">{{ dashboard_summary }}.</span>
                </h4>
              </div>

              <div v-if="active_dashboard_mode === 'executive'">
                <h4 class="fw-semibold mb-1 text-start">
                  {{ user.name }} - Executive Dashboard
                </h4>
                <p class="text-muted mb-0">
                  High-level insights across products, revenue and organizational health
                </p>
              </div>

              <div v-if="active_dashboard_mode === 'team'">
                <h4 class="fw-semibold mb-1 text-start">
                  {{ user.name }} - Team Performance Dashboard
                </h4>
                <p class="text-muted mb-0">
                  {{ team_data.name }} • Team Lead: {{ team_data.lead }}
                </p>
              </div>


              <div class="d-flex flex-wrap justify-content-center justify-content-lg-end gap-2">

                <button
                  v-if="can_view_my_dashboard"
                  class="overview-btn"
                  :class="{ active: active_dashboard_mode === 'my' }"
                  @click="set_dashboard_mode('my')"
                  title="Personal dashboard with your tasks and activities"
                >
                  <i class="fa-solid fa-user me-1"></i>
                  My Overview
                </button>

                <!-- Team Overview - Available to org_admin and system_admin -->
                <button
                  v-if="can_view_team_dashboard"
                  class="overview-btn"
                  :class="{ active: active_dashboard_mode === 'team' }"
                  @click="set_dashboard_mode('team')"
                  title="Team performance metrics and collaboration"
                >
                  <i class="fa-solid fa-users me-1"></i>
                  Team Overview
                </button>

                <!-- Executive Overview - Available ONLY to system_admin -->
                <button
                  v-if="can_view_executive_dashboard"
                  class="overview-btn"
                  :class="{ active: active_dashboard_mode === 'executive' }"
                  @click="set_dashboard_mode('executive')"
                  title="Executive-level insights and analytics"
                >
                  <i class="fa-solid fa-chart-line me-1"></i>
                  Executive Overview
                </button>
              </div>
            </div>

            <!-- KPI row: Top metrics -->
            <div v-if="active_dashboard_mode === 'my'" class="row g-3 mt-3">
              <div class="col-12 col-sm-6 col-lg-3" v-for="metric in top_metrics" :key="metric.label">
                <div class="card h-100 border-0 rounded-4 shadow-lg border-0 border-top border-3 border-danger">
                  <div class="card-body p-3">
                    <div class="d-flex align-items-center justify-content-between mb-2">
                      <span class="text-muted small">{{ metric.label }}</span>
                      <i :class="metric.icon" :style="{color: metric.color}"></i>
                    </div>
                    <div class="h4 fw-bold mb-0">{{ metric.value }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="active_dashboard_mode === 'executive'" class="row g-3 mt-3">
              <div class="col-12 col-sm-6 col-lg-3" v-for="kpi in executive_kpis" :key="kpi.label">
                <div class="card h-100 border-0 rounded-4 shadow-lg border-0 border-top border-3 border-danger">
                  <div class="card-body p-3">
                    <div class="d-flex align-items-center justify-content-between mb-2">
                      <span class="text-muted small">{{ kpi.label }}</span>
                        <i :class="kpi.icon" :style="{color: kpi.color}"></i>
                    </div>
                    <div class="h4 fw-bold mb-0">{{ kpi.value }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="active_dashboard_mode === 'team'" class="row g-3 mt-3">
              <div class="col-12 col-md-6 col-lg-3" v-for="metric in key_metrics" :key="metric.label">
                <div class="card h-100 border-0 rounded-4 shadow-lg border-0 border-top border-3 border-danger">
                  <div class="card-body p-3">
                    <div class="d-flex align-items-center justify-content-between mb-2">
                      <span class="text-muted small">{{ metric.label }}</span>
                      <i :class="metric.icon" :style="{ color: metric.color }"></i>
                    </div>
                    <div class="h4 fw-bold mb-0">{{ metric.value }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="active_dashboard_mode === 'team'" class="team-dashboard">
          <TeamDashboard />
        </div>

        <div v-if="active_dashboard_mode === 'executive'" class="executive-wrapper">
          <ExecutiveDashboard />
        </div>

        <!-- Main Dashboard Grid -->
        <div v-if="active_dashboard_mode === 'my'" class="row g-3">
          <!-- Personal Storage Card -->
          <div class="col-12 col-lg-3">
            <div class="card border-0 rounded-4 shadow-lg h-100 cursor-pointer" @click="go_to_page('/drive')">
              <div class="card-body p-4">
                <div class="d-flex align-items-center justify-content-between mb-3">
                  <h6 class="mb-0 fw-semibold">Personal Storage</h6>
                  <i class="fa-solid fa-database personal-storage"></i>
                </div>
                <div class="mb-2">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <span class="h5 fw-bold mb-0">{{ used_gb || 0 }} GB</span>
                    <span class="text-muted small">of {{ total_gb || 5 }} GB</span>
                  </div>
                  <div class="progress progress-storage">
                    <div class="progress-bar bg-dark storage-bar" role="progressbar"
                    ref="storage_progress_bar"
                    :aria-valuenow="percentage_used || 0"
                    aria-valuemin="0" 
                    aria-valuemax="100"></div>
                  </div>
                  <div class="text-muted small mt-2">{{ available_gb || 0 }} GB available</div>
                </div>
              </div>
            </div>
          </div>

          <!-- System Health Card -->
          <div class="col-12 col-lg-3">
            <div class="card border-0 rounded-4 shadow-lg h-100">
              <div class="card-body p-4">
                <div class="d-flex align-items-center justify-content-between mb-3">
                  <h6 class="mb-0 fw-semibold">System Health</h6>
                  <i class="fa-solid fa-heartbeat system-health"></i>
                </div>
                <div class="d-flex align-items-center gap-2 mb-3">
                  <i class="fa-solid fa-circle-check system-health"></i>
                  <span class="fw-semibold">All Systems Operational</span>
                </div>
                <div class="mb-2">
                  <div class="d-flex justify-content-between mb-1">
                    <span class="small text-muted">Performance</span>
                    <span class="small fw-semibold">98%</span>
                  </div>
                  <div class="progress mb-3 performance-bar">
                    <div class="progress-bar bg-success w-100"></div>
                  </div>
                  <div class="d-flex justify-content-between mb-1">
                    <span class="small text-muted">Uptime</span>
                    <span class="small fw-semibold">99.9%</span>
                  </div>
                  <div class="progress performance-bar">
                    <div class="progress-bar bg-dark w-100"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- IC Workbook Card -->
          <div class="col-12 col-lg-6">
            <div class="card border-0 rounded-4 shadow-lg h-100" >
              <div class="card-body p-4">
                <div class="d-flex align-items-center justify-content-between mb-3">
                  <h6 class="mb-0 fw-semibold">IC Workbook</h6>
                  <img :src="cardImages.engagenet" alt="IC Workbook" class="icon-32 object-fit-contain" />
                </div>
                <div class="d-flex flex-column gap-3">
                  <div class="d-flex align-items-start gap-3">
                    <div class="rounded-circle d-flex align-items-center justify-content-center icon-32 bg-white">
                      <i class="fa-solid fa-calendar text-primary small"></i>
                    </div>
                    <div class="flex-grow-1">
                       <div class="fw-semibold small">Upcoming Events</div>

                        <div v-if="upcoming_events.length > 0" class="text-muted custom-font">
                          Next: {{ upcoming_events[0].event_name }} ({{ upcoming_events[0].start_date }})
                        </div>

                        <div v-else class="text-muted custom-font">
                          No upcoming events
                        </div>
                     </div>
                    <span class="badge rounded-pill bg-white text-dark">{{ upcoming_events.length }}</span>
                  </div>
                  <div class="d-flex align-items-start gap-3">
                    <div class="rounded-circle d-flex align-items-center justify-content-center icon-32 bg-white">
                      <i class="fa-solid fa-file-alt text-purple small"></i>
                    </div>
                    <div class="flex-grow-1">
                      <div class="fw-semibold small">Document Approvals</div>
                      <div class="text-muted custom-font">Requires your approval</div>
                    </div>
                    <span class="badge rounded-pill bg-white text-dark">{{ pending_approvals }}</span>
                  </div>
                  <div class="d-flex align-items-start gap-3">
                    <div class="rounded-circle d-flex align-items-center justify-content-center icon-32 bg-white">
                      <i class="fa-solid fa-bell text-success small"></i>
                    </div>
                    <div class="flex-grow-1">
                      <div class="fw-semibold small">New Updates</div>
                      <div class="text-muted custom-font">Policy changes & announcements</div>
                    </div>
                    <span class="badge rounded-pill bg-white text-dark">7</span>
                  </div>
                </div>
              </div>
            </div>
          </div>



          <!-- Tasks Assigned to You -->
          <div class="col-12 col-lg-6">
            <div class="card border-0 rounded-4 shadow-lg h-100">
              <div class="card-body p-4">
                <div class="d-flex align-items-center justify-content-between mb-3">
                  <h6 class="mb-0 fw-semibold">Tasks Assigned to You</h6>
                  <i class="fa-solid fa-tasks"></i>
                </div>
                <div class="d-flex gap-3 mb-3">
                  <div class="d-flex align-items-center gap-2">
                    <i class="fa-regular fa-clock text-primary"></i>
                    <span class="small">3 Assigned</span>
                  </div>
                  <div class="d-flex align-items-center gap-2">
                    <i class="fa-solid fa-exclamation-triangle text-danger"></i>
                    <span class="small">1 Overdue</span>
                  </div>
                </div>
                <div class="d-flex flex-column gap-3">
                  <div class="d-flex align-items-center justify-content-between p-2 rounded bg-light">
                    <div class="flex-grow-1">
                      <div class="fw-semibold small">Review Q4 Financial Report</div>
                      <div class="text-muted custom-font">IC Workbook • Due Nov 20</div>
                    </div>
                    <span class="badge bg-secondary">assigned</span>
                  </div>
                  <div class="d-flex align-items-center justify-content-between p-2 rounded bg-light">
                    <div class="flex-grow-1">
                      <div class="fw-semibold small">Complete AI Module</div>
                      <div class="text-muted custom-font" >Orcaa • Due Nov 15</div>
                    </div>
                    <span class="badge bg-danger">overdue</span>
                  </div>
                  <div class="d-flex align-items-center justify-content-between p-2 rounded bg-light">
                    <div class="flex-grow-1">
                      <div class="fw-semibold small">Update Compliance Profile</div>
                      <div class="text-muted custom-font">ComplyOn • Due Nov 25</div>
                    </div>
                    <span class="badge bg-secondary">assigned</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Courses & Training -->
          <div class="col-12 col-lg-6">
            <div class="card border-0 rounded-4 shadow-lg h-100">
              <div class="card-body p-4">
                <div class="d-flex align-items-center justify-content-between mb-3">
                  <h6 class="mb-0 fw-semibold">Courses & Learning</h6>
                  <img :src="cardImages.orcaa" alt="Orcaa" class="icon-32 object-fit-contain" />
                </div>

                <!-- Loading State -->
                <div v-if="courses_loading" class="text-center py-4">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading courses...</span>
                  </div>
                  <p class="text-muted small mt-2">Loading your courses...</p>
                </div>

                <!-- No Courses -->
                <div v-else-if="!courses || courses.length === 0" class="text-center py-4">
                  <i class="fa-solid fa-book-open fa-2x text-muted mb-3"></i>
                  <p class="text-muted">No courses enrolled yet</p>
                </div>

                <!-- Courses List -->
                <div v-else class="d-flex flex-column gap-3">
                  <!-- Display first 3 courses -->
                  <div v-for="course in courses.slice(0, 3)" :key="course.id">
                    <div class="d-flex justify-content-between align-items-start mb-2">
                      <div class="fw-semibold small flex-grow-1">{{ course.course_name }}</div>
                      <span v-if="course.course_price === '0' || course.course_price === '0.00'"
                            class="badge rounded-pill bg-success text-white ms-2">Free</span>
                      <span v-else
                            class="badge rounded-pill bg-primary text-white ms-2">R{{ course.course_price }}</span>
                    </div>

                    <!-- Course Overview -->
                    <div class="text-muted custom-font small overflow-hidden text-truncate mb-2">
                      {{ course.course_overview }}
                    </div>

                    <!-- Course Status -->
                    <div class="d-flex align-items-center gap-2">
                      <span class="small text-muted">Status:</span>
                      <span
                        class="badge rounded-pill"
                        :class="{
                          'bg-secondary': course.status === 'Not started',
                          'bg-info': course.status === 'In progress',
                          'bg-success': course.status === 'Completed',
                          'bg-warning text-dark': course.status === 'Paused'
                        }">
                        {{ course.status }}
                      </span>
                    </div>
                  </div>

                  <!-- Total Courses Count -->
                  <div class="d-flex justify-content-center mt-2 pt-3 border-top">
                    <div class="text-center">
                      <div class="h5 fw-bold mb-0">{{ courses.length }}</div>
                      <div class="text-muted small">Total Courses</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <!-- Ongoing Cases -->
          <div class="col-12 col-lg-6">
            <div class="card border-0 rounded-4 shadow-lg h-100">
              <div class="card-body p-4">
                <div class="d-flex align-items-center justify-content-between mb-3">
                  <h6 class="mb-0 fw-semibold">Ongoing Cases</h6>
                  <img :src="cardImages.xverdict" alt="IC Workbook" class="icon-32 object-fit-contain" />
                </div>
                <div class="d-flex flex-column gap-3">
                  <div class="d-flex align-items-center justify-content-between p-2 rounded bg-light">
                    <div class="flex-grow-1">
                      <div class="fw-semibold small">Employee Dispute Case #2847</div>
                      <div class="text-muted custom-font">Nov 10, 2024</div>
                    </div>
                    <span class="badge rounded-pill bg-white text-dark">in progress</span>
                  </div>
                  <div class="d-flex align-items-center justify-content-between p-2 rounded bg-light">
                    <div class="flex-grow-1">
                      <div class="fw-semibold small">Contract Review #3012</div>
                      <div class="text-muted custom-font">Nov 8, 2024</div>
                    </div>
                    <span class="badge rounded-pill bg-white text-dark">referred</span>
                  </div>
                  <div class="d-flex align-items-center justify-content-between p-2 rounded bg-light">
                    <div class="flex-grow-1">
                      <div class="fw-semibold small">Policy Violation Investigation</div>
                      <div class="text-muted custom-font">Nov 5, 2024</div>
                    </div>
                    <span class="badge rounded-pill bg-white text-dark">completed</span>
                  </div>
                  <div class="d-flex justify-content-around mt-2 pt-2 border-top">
                    <div class="text-center">
                      <div class="h5 fw-bold mb-0">1</div>
                      <div class="text-muted small">Referred</div>
                    </div>
                    <div class="text-center">
                      <div class="h5 fw-bold mb-0">1</div>
                      <div class="text-muted small">In Progress</div>
                    </div>
                    <div class="text-center">
                      <div class="h5 fw-bold mb-0">1</div>
                      <div class="text-muted small">Completed</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Pending Requests Card -->
          <div class="col-12 col-lg-6">
            <div class="card border-0 rounded-4 shadow-lg h-100">
              <div class="card-body p-4">
                <div class="d-flex align-items-center justify-content-between mb-4">
                  <div class="d-flex align-items-center gap-2">
                    <h6 class="mb-0 fw-semibold">Pending Requests</h6>
                    <span class="badge rounded-pill request-card">{{ pending_requests }}</span>
                  </div>
                  <img :src="cardImages.complyon" alt="IC Workbook" class="icon-32 object-fit-contain" />
                </div>

                <!-- Loading State -->
                <div v-if="pending_requests_loading" class="text-center py-4">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading requests...</span>
                  </div>
                  <p class="text-muted small mt-2">Loading your pending requests...</p>
                </div>

                <!-- Empty State -->
                <div v-else-if="!pending_requests_list || pending_requests_list.length === 0" class="text-center py-5">
                  <i class="fa-regular fa-circle-check text-success fa-2x"></i>
                  <p class="text-muted mt-3 mb-0">No pending requests</p>
                </div>

                <!-- Pending Requests List -->
                <div v-else class="d-flex flex-column gap-3">
                  <div
                    v-for="(request, index) in pending_requests_list.slice(0, 3)"
                    :key="request.id"
                    class="p-3 rounded-3 bg-light position-relative"
                  >
                    <!-- Status Badge -->
                    <span class="badge bg-warning text-dark position-absolute top-0 end-0 m-2">Pending</span>

                    <!-- Message -->
                    <p class="mb-3 pe-5 fw-medium text-dark">{{ request.message }}</p>

                    <!-- Requested Fields -->
                    <div v-if="request.requested_fields && request.requested_fields.length > 0" class="mb-3">
                      <div
                        v-for="field in request.requested_fields"
                        :key="field.requested_field_id"
                        class="d-flex align-items-start gap-2 mb-2 ps-2"
                      >
                        <i class="fa-solid fa-file-circle-exclamation text-warning mt-1"></i>
                        <div class="flex-grow-1">
                          <div class="small text-muted">{{ field.form_section_name }}</div>
                          <div class="small fw-medium text-dark">{{ field.requested_field_text }}</div>
                        </div>
                      </div>
                    </div>

                    <!-- Date -->
                    <div class="d-flex align-items-center gap-2 text-muted small">
                      <i class="fa-regular fa-clock"></i>
                      <span>{{ format_date(request.date_created) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- My Activity Log -->
          <div class="col-12">
            <div class="card border-0 rounded-4 shadow-lg">
              <div class="card-body p-4">
                <div class="d-flex align-items-center justify-content-between mb-3">
                  <h6 class="mb-0 fw-semibold">My Activity Log</h6>
                  <i class="fa-solid fa-history"></i>
                </div>

                <!-- Loading State -->
                <div v-if="audits_loading" class="text-center py-5">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading activity...</span>
                  </div>
                  <p class="text-muted small mt-2">Loading your activity log...</p>
                </div>

                <!-- No Permission State -->
                <div v-else-if="!has_audit_permission" class="text-center py-5">
                  <i class="fa-solid fa-lock text-muted fa-2x mb-3"></i>
                  <p class="text-muted mb-0">No permission to view activity log</p>
                </div>

                <!-- Empty State -->
                <div v-else-if="!audits || audits.length === 0" class="text-center py-5">
                  <i class="fa-solid fa-history text-muted fa-2x mb-3"></i>
                  <p class="text-muted mb-0">No recent activity</p>
                </div>

                <!-- Activity Table -->
                <div v-else class="table-responsive dashboard-activity-log">
                  <table class="table table-hover align-middle mb-0 dashboard-activity-table">
                    <thead class="table-light">
                      <tr>
                        <th class="border-0 small">Action</th>
                        <th class="border-0 small">Timestamp</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(log, idx) in recent_from_audits" :key="idx" class="dashboard-activity-row">
                        <td class="dashboard-activity-action-cell">
                          <div class="d-flex align-items-center gap-3">
                            <div class="activity-chip d-inline-flex align-items-center justify-content-center">
                              <img src="@/assets/aicone.png" class="img-fluid w-50 h-75" />
                            </div>
                            <span class="small dashboard-activity-message">{{ log.d }}</span>
                          </div>
                        </td>
                        <td class="text-muted small dashboard-activity-time">{{ log.t }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Spacer -->
        <div class="my-4"></div>
      </div>
    </div>

    <!-- Kubiki AI slide-out -->
    <transition name="slide-left">
      <div v-if="ai_open" class="kubiki-panel position-fixed end-0 d-flex flex-column shadow-lg">
        <div class="d-flex align-items-center justify-content-between p-3 border-bottom">
          <div class="d-flex align-items-center gap-2">
            <i class="fa-solid fa-cpu"></i>
            <span class="fw-semibold">Kubiki AI Assistant</span>
          </div>
          <button class="btn btn-link text-dark" @click="ai_open = false">✕</button>
        </div>

        <div class="p-3">
          <p class="small text-muted mb-2">Ask things like:</p>
          <ul class="small ps-3">
            <li>"Generate a compliance report from Proba for Chris Hani Municipality."</li>
            <li>"Show KYC workflows pending approval in ComplyOn."</li>
            <li>"Summarize the last 24h audit events across all apps."</li>
          </ul>

          <div class="mt-3">
            <input class="form-control rounded-3" placeholder="Type a command…" />
            <div class="d-flex gap-2 mt-2">
              <button class="btn upload-button rounded-3">Run</button>
              <button class="btn upload-button rounded-3">Suggest</button>
            </div>
          </div>
        </div>

        <div class="mt-auto p-3 border-top xxs text-muted">
          You are signed in as <span class="fw-semibold text-dark">{{ user.name }}</span>
        </div>
      </div>
    </transition>
</div>
